import Api from '@/services/Api' // axois object created in api.js
import { Paging } from '@/util/paging'
import { UserWithdrawRecord } from '@/types'
const prefix = '/finance/'

export default {
  // abosulete
  getOrgWithdrawRecords (
    withdrawStatusCodes: string[],
    organizationId?: number,
    limit?: number,
    offset?: number
  ) {
    return Api().get(prefix + 'org-withdraw-records', {
      params: { withdrawStatusCodes, organizationId, limit, offset }
    })
  },
  // abosulete
  approveAndFulfillOrgWithdrawRequest (orgWithdrawId: number) {
    return Api().post(prefix + 'approve-and-fulfill-org-withdraw-request', {
      orgWithdrawId: orgWithdrawId
    })
  },
  // 取得用户提现请求
  getUserWithdrawRecords (
    withdrawStatusCodes: string[],
    userId?: number,
    limit?: number,
    offset?: number,
    detail?: boolean,
    paging?: boolean
  ) {
    return Api().get(prefix + 'user-withdraw-records', {
      params: { withdrawStatusCodes, userId, limit, offset, detail, paging }
    })
  },
  // 分页取得用户提现请求
  getUserWithdrawRecordsPaging (data: {detail?: boolean; withdrawStatusCodes?: number[]; userId?: number; id?: number }): Paging<UserWithdrawRecord> {
    return new Paging(
      {
        url: 'finance/user-withdraw-records', // 请求的地址
        data // 请求的数据
      },
      12 // 默认每次取得的提现数据条数
    )
  },
  // 批准用户提现请求
  approveAndFulfillUserWithdrawRequest (userWithdrawId: number) {
    return Api().post(prefix + 'approve-and-fulfill-user-withdraw-request', {
      userWithdrawId: userWithdrawId
    })
  }
}
